/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('preventEnterSubmit', preventEnterSubmit);

    function preventEnterSubmit() {
        return {
            restrict: 'A',
            link: function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 === event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            }
        };
    }
})();


/*
Prevent in whole JS (put in controller)
angular.element(document).ready(function () {
    angular.element(window).keydown(function () {
        if(event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    });
});

Alternative (with shift support)
function (scope, elem, attrs) {
    elem.bind('keydown', function(event) {
         var code = event.keyCode || event.which;
         if (code === 13) {
               if (!event.shiftKey) {
                    event.preventDefault();
                    scope.$apply(attrs.enterSubmit);
               }
         }
    });
}
*/
